import { PRODUCT_MAPPINGS_LOADED, PRODUCT_MAPPING_UPDATED } from '../components/actions/productMappingTypes'

const initialState = {
  loading: true,
  productMappings: null,
}

const productMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_MAPPINGS_LOADED:
      state.productMappings = action.payload
      state.loading = false
      return state
    case PRODUCT_MAPPING_UPDATED:
      const index = state.productMappings.findIndex((p) => p.id === action.payload.id)
      state.productMappings[index] = action.payload
      return state
    default:
      return state
  }
}

export default productMappingReducer
